import React, { useState } from "react";
import { Menu, MenuItem, CircularProgress } from "@mui/material";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

const CouponEditMenu = ({ selectedCoupon, anchorEl, onClose, refetchCoupons, onEdit, handleDelete, handleViewHistory }) => {
    const services = useAppServices();
    const [agency] = useAgencyInfo();
    const [loadingDuplicate, setLoadingDuplicate] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const handleEdit = () => {
        onEdit(selectedCoupon);
        onClose();
    };

    const handleDuplicate = async () => {
        setLoadingDuplicate(true);
        try {
            const duplicatePayload = {
                agency_id: agency._id,
                code: selectedCoupon.code,
            };
            const result = await services.coupons.duplicateCoupon({
                payload: duplicatePayload,
                toaster: true,
            });
            refetchCoupons();
            onClose();
        } catch (error) {
            console.error("Error duplicating coupon:", error);
        } finally {
            setLoadingDuplicate(false);
        }
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={(loadingDuplicate || loadingDelete) ? undefined : onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <MenuItem onClick={() => { handleViewHistory(selectedCoupon); onClose() }}>
                View History
            </MenuItem>
            <MenuItem onClick={handleEdit} disabled={loadingDuplicate || loadingDelete}>
                Edit
            </MenuItem>
            <MenuItem onClick={handleDuplicate} disabled={loadingDuplicate || loadingDelete}>
                {loadingDuplicate && <CircularProgress size={16} sx={{ mr: 1 }} />}
                Duplicate
            </MenuItem>
            <MenuItem
                onClick={() => { handleDelete(selectedCoupon); onClose() }}
                disabled={loadingDuplicate || loadingDelete || selectedCoupon?.coupon?.times_redeemed > 0}
                sx={{ color: 'error.main' }}
            >
                {loadingDelete && <CircularProgress size={16} sx={{ mr: 1 }} />}
                Delete
            </MenuItem>
        </Menu>
    );
};

export default CouponEditMenu;